<template>
    <div>
        <span v-html="$t('notification.taskStageChanged', {user: getActorName, task: $_.get(activity, 'payload.name'), oldStage: $_.get(activity, 'payload.oldStage'), newStage: $_.get(activity, 'payload.newStage') })"></span><span v-if="ruleSource"> (<em>{{ ruleSource }}</em> aracılığıyla)</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskStageChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getActorName() {
            const actorName = this.$_.get(this.activity, "actorUser.name");
            if (actorName) return actorName;
            if (this.$_.get(this.activity, "actor") === "system") return "Sistem";
            return "Bilinmeyen";
        },
        ruleSource() {
            return this.$_.get(this.activity, "payload.ruleSource");
        }
    }
});
</script>

<style scoped lang="scss"></style>
